"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Option = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireDefault(require("react"));
var _optionModule = _interopRequireDefault(require("./option.module.scss"));
var _classnames = _interopRequireDefault(require("classnames"));
var _done = require("../../assets/icons/done.svg");
var _noop = require("../../utils/noop");
var _excluded = ["className", "children", "selected", "label", "value", "onClick"];
var OptionInner = function OptionInner(_ref, ref) {
  var className = _ref.className,
    children = _ref.children,
    selected = _ref.selected,
    label = _ref.label,
    value = _ref.value,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? _noop.noop : _ref$onClick,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("li", Object.assign({
    ref: ref,
    className: (0, _classnames.default)(_optionModule.default['option'], selected && _optionModule.default['option--selected'], className),
    onClick: onClick,
    value: value
  }, rest), children, selected && /*#__PURE__*/_react.default.createElement(_done.ReactComponent, {
    className: _optionModule.default['option__icon']
  }), label && /*#__PURE__*/_react.default.createElement("span", {
    id: 'option-label',
    className: _optionModule.default['option__label']
  }, label));
};
var Option = /*#__PURE__*/_react.default.forwardRef(OptionInner);
exports.Option = Option;